import { connect } from 'react-redux';
import { setProductCode } from 'actions/bookingWidget';
import MODAL_KEYS from 'constants/modals';
import { clearDiscountInReservationFlow } from 'actions/reservation/clearDiscountInReservationFlow';
import { closeModal } from 'actions/modal/closeModal';
import { openModal } from 'actions/modal/openModal';
import CouponNavigationBanner from './CouponNavigationBanner';

const mapDispatchToProps = {
  setProductCode,
  clearDiscountInReservationFlow,
  closeModal,
  openRemoveProductCodeModal: (productCode, onConfirm) =>
    openModal(MODAL_KEYS.REMOVE_PRODUCT_CODE_MODAL, { props: { productCode, onConfirm } }),
  openRemoveCouponModal: (couponDescription) =>
    openModal(MODAL_KEYS.REMOVE_COUPON_MODAL, { props: { couponDescription } }),
};

export default connect(null, mapDispatchToProps)(CouponNavigationBanner);
